<template>


  <el-container>
    <el-header height="7vh">
      <div class="logo x-flex">
        <img src="../../src/assets/img/logo.png" alt="logo" />
        <span class="x-p-l-10"> 服务商管理系统</span>
      </div>
      <div class="right">
        <!-- <div class='x-flex x-m-r-20 x-cur-poi' @click='showImg = true'
          style="color: #606266;font-size: 14px; border: 1px solid #cfcfcf; padding: 0  14px 0 0px; border-radius: 20px;">
          <img src="../assets/img/appLet.png" alt="" />
          小程序
        </div> -->
        <div class='x-m-r-20 ' style="color: #606266;font-size: 14px;">
          机构：{{ $store.state.smElabelOrgInfo.orgName }} {{ $store.state.smElabelOrgInfo.orgId }}
        </div>
        <div class="">
          <img src="../assets/img/user_logo.png" alt="" />
        </div>
        <el-dropdown>
          <span class="el-dropdown-link">
            {{ $store.state.smElabelOrgInfo.userName }} {{ $store.state.smElabelOrgInfo.userId }}<i
              class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item>
              <div @click="modifyPwdDislog = !modifyPwdDislog">修改密码</div>
            </el-dropdown-item> -->
            <el-dropdown-item>
              <div @click="logout">注销登录</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container style="height:calc( 100vh - 7vh);overflow: hidden;">
      <el-aside width="150px">
        <el-menu default-active="/payment" class="el-menu-vertical-demo" active-text-color="#FF5A32" router>
          <el-menu-item index="/home" :class="['aside-item',asideId == '0001' ? 'aside-item-active' : '',]" @click="">
            <img
              :src='asideId == "0001" ? require("../../src/assets/img/xtsy-1.png"):require("../../src/assets/img/xtsy-0.png")'
              style="width: 15px; height: 15px" class="x-m-r-10" />
            <span slot="title">系统首页</span>
          </el-menu-item>
          <el-menu-item v-if="Number($store.state.smElabelOrgInfo.org_level) <= 2" index="/orgAdmin"
            :class="['aside-item',asideId == '0002' ? 'aside-item-active' : '',]" @click="">
            <img
              :src='asideId == "0002" ? require("../../src/assets/img/jggl-1.png"):require("../../src/assets/img/jggl-0.png")'
              style="width: 15px; height: 15px" class="x-m-r-10" />
            <span slot="title">机构管理</span>
          </el-menu-item>
          <el-menu-item index="/mchAdmin" :class="['aside-item',asideId == '0003' ? 'aside-item-active' : '',]"
            @click="">
            <img
              :src='asideId == "0003" ? require("../../src/assets/img/shgl-1.png"):require("../../src/assets/img/shgl-0.png")'
              style="width: 15px; height: 15px" class="x-m-r-10" />
            <span slot="title">商户管理</span>
          </el-menu-item>
          <el-menu-item index="/elabelAdmin" :class="['aside-item',asideId == '0004' ? 'aside-item-active' : '',]"
            @click="">
            <img
              :src='asideId == "0004" ? require("../../src/assets/img/jqgl-1.png"):require("../../src/assets/img/jqgl-0.png")'
              style="width: 15px; height: 15px" class="x-m-r-10" />
            <span slot="title">价签管理</span>
          </el-menu-item>
          <el-menu-item v-if="$store.state.smElabelOrgInfo.orgId == 'smLot' || $store.state.smElabelOrgInfo.orgId == '17898841736' " index="/templateList"
            :class="['aside-item',asideId == '0005' ? 'aside-item-active' : '',]" @click="">
            <img
              :src='asideId == "0005" ? require("../../src/assets/img/jqgl-1.png"):require("../../src/assets/img/jqgl-0.png")'
              style="width: 15px; height: 15px" class="x-m-r-10" />
            <span slot="title">模板设计</span>
          </el-menu-item>

        </el-menu>
      </el-aside>
      <el-main class='x-flex ' style="flex-direction: column;">
        <!-- <div class="x-w100p x-p-r-8 x-p-l-8 x-p-b-8 x-text-center">{{ asideName }}</div> -->
        <div class='x-flex-1 x-w100p'>
          <router-view></router-view>
        </div>
      </el-main>
    </el-container>
    <el-dialog title="" :visible.sync="modifyPwdDislog" width="500px" :close-on-click-modal="false">
      <div class="x-flex x-row-center x-font-16 f600 x-m-b-30">修改密码</div>
      <el-row class="x-m-t-15">
        <el-col class="x-flex x-p-r-15" :span="24">
          <div class="x-w90 x-text-r x-p-r-15">旧密码</div>
          <el-input type="text" v-model="oldPwd" size="small"></el-input>
        </el-col>
        <el-col class="x-flex x-p-r-15 x-m-t-15" :span="24">
          <div class="x-w90 x-text-r x-p-r-15">新密码</div>
          <el-input type="text" v-model="newPwd" size="small" show-password></el-input>
        </el-col>
        <el-col class="x-flex x-p-r-15 x-m-t-15" :span="24">
          <div class="x-w90 x-text-r x-p-r-15">确认密码</div>
          <el-input type="text" v-model="confirmPwd" size="small" show-password></el-input>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="fEditPwdClose" size="small">取 消</el-button>
        <el-button type="primary" @click="fSaveEditPwd" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="showImg" width="400px" :close-on-click-modal="true">
      <img style="width: 400px;" src="../../src/assets/img/appLetQR.jpg" alt="" />
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    data() {
      return {
        showImg: false,
        userName: this.$store.state.smElabelOrgInfo.userName,
        path: "/orgAdmin",
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
        asideList1: [{
            a_id: "0010",
            a_name: "产品码库",
            a_path: "/codeManger",
            a_component: "codeManger",
            icon: require("../../src/assets/img/codeManger.png"),
          },



        ],
        asideList: [],
        asideId: "",
        asideName: "",
        modifyPwdDislog: false, // 修改密码的弹窗
      };
    },
    computed: {
      key() {
        return this.$route.path + Math.random();
      },
    },
    created() {
      this.fSetActive()
    },
    watch: {
      '$route': 'fSetActive', //监听路由变化
    },
    methods: {
      //设置选中状态
      fSetActive(type) {
        // 获取地址栏中的路由
        let defaultMenu = window.location.hash.substr(
          window.location.hash.indexOf("/")
        );
        defaultMenu = defaultMenu.split('?')[0]
        console.log(defaultMenu)
        if (defaultMenu == '/home') {
          this.path = '/home';
          this.asideId = '0001';
          this.asideName = '系统首页';
          return
        }
        if (defaultMenu == '/orgAdmin') {
          this.path = '/orgAdmin';
          this.asideId = '0002';
          this.asideName = '机构管理';
          return
        }
        if (defaultMenu == '/mchAdmin') {
          this.path = '/mchAdmin';
          this.asideId = '0003';
          this.asideName = '商户管理';
          return
        }
        if (defaultMenu == '/elabelAdmin') {
          this.path = '/elabelAdmin';
          this.asideId = '0004';
          this.asideName = '价签管理';
          return
        }
        if (defaultMenu == '/templateList') {
          this.path = '/templateList';
          this.asideId = '0005';
          this.asideName = '模板设计';
          return
        }
        this.asideList.forEach((item) => {
          if (item.a_path == defaultMenu) {
            this.asideId = item.a_id;
            this.asideName = item.a_name;
            this.path = item.a_path;
          }
        })
      },
      fAsideChoose(id, name, path) {

        // this.asideId = id;
        // this.asideName = name;
        // sessionStorage.setItem("path", path);
        // sessionStorage.setItem("id", id);
        // sessionStorage.setItem("name", name);
      },
      // 注销登录
      logout() {
        localStorage.removeItem("bykPlatform");
        this.$router.push("/login");
      },
      async fSaveEditPwd() {
        if (this.bykApi.smCom.fSmIsEmpty(this.oldPwd)) {
          return this.$message("请输入旧密码");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.newPwd)) {
          return this.$message("请输入新密码");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.confirmPwd)) {
          return this.$message("请输入确认密码");
        }
        if (this.newPwd != this.confirmPwd) {
          return this.$message("两次新密码不一致");
        }
        let res = await this.fBykGetPartnerChgPsw();
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.$message(res.msg);
        this.fEditPwdClose();
        return;
      },

      // 取消修改密码
      fEditPwdClose() {
        this.oldPwd = "";
        this.newPwd = "";
        this.confirmPwd = "";
        this.modifyPwdDislog = false;
      },

      // ------------ 请求 开始 -------------

      // 修改密码
      async fBykGetPartnerChgPsw() {
        let js = {};
        js["PARTNER_PHONE"] = this.bykApi.global.fGetPlatform().partnerInfo.phone;
        js["OLD_PSW"] = this.oldPwd;
        js["NEW_PSW"] = this.newPwd;
        // let res = await this.bykApi.postApi.fPostToBykPlatFormoApi(postJson);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('PARTNER_CHG_PSW', js);
        return res;
      },

      // ------------ 请求 结束 -------------
    },
  };
</script>

<style lang="less" scoped>
  .el-aside {
    font-size: 16px;
    height: 100vh;
    background-color: #fff;

    //   font-weight: bold;
    .logo {

      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: auto;
        height: 50px;
      }
    }

    .aside-item {
      // a {
      // color: #f2f2f2;
      // }
      color: #000000;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // padding-left: 30px;
    }

    .aside-item-active {
      background-color: #FFEEEA;
      color: #FF5A32;
    }
  }

  .el-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 20px;
    font-size: 16px;
    font-weight: bold;

    .right {
      display: flex;
      align-items: center;
      font-weight: 500;

      img {
        width: 30px;
        margin-right: 5px;
        height: 30px;
        border-radius: 50%;
        // background-color: rgb(138, 138, 138);
      }
    }

    .right:hover {
      .edit-pwd {
        display: flex;
      }
    }
  }

  .el-main {
    background-color: #f5f5f5;
    padding: 8px 8px 0;
  }

  /deep/ .el-menu {
    border: 0;
    background-color: #fff;
  }

  /deep/ .el-menu-item:hover {
    background-color: #FFEEEA;
    color: #FF5A32;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue